import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'

@Component({
  selector: 'mmx-file-uploader',
  templateUrl: './file-uploader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
  ],
})
export class FileUploaderComponent {
  @Input()
  public label: string

  @Input()
  public accept: string

  @Input()
  public maxSize: number

  @Input()
  public fileSizeError: string

  @Input()
  public fileTypeError: string

  @Input()
  public disabled: boolean = false

  @Output()
  public fileUploaded = new EventEmitter<File[]>()

  public error: string | null

  constructor(
    private cdr: ChangeDetectorRef,
  ) { }

  public onUpload() {
    this.error = null
    const input = document.createElement('input')
    input.type = 'file'
    input.multiple = true
    if (this.accept) {
      input.accept = this.accept
    }

    input.onchange = () => {
      const files: File[] = []
      if (input.files?.length) {
        for (const file of Array.from(input.files)) {
          if (this.maxSize && file.size > this.maxSize * 1024 * 1024) {
            this.error = this.fileSizeError
            continue
          }

          if (this.accept && !this.accept.split(',').includes(file.type)) {
            this.error = this.fileTypeError
            continue
          }

          files.push(file)
        }

        if (files.length) {
          this.fileUploaded.emit(files)
        }
        this.cdr.detectChanges()
      }
    }
    input.click()
  }
}
